import React from 'react'
import ReactDOM from 'react-dom'
import Index from './Index'

// temporary use event turbolinks until turbolinks unused
// document.addEventListener('DOMContentLoaded', () => {
document.addEventListener('turbolinks:load', () => {
  ReactDOM.render(<Index />, document.getElementById('main-app'))
})
